/**
 * @file: description
 * @author:
 * @Date: 2020-03-25 17:22:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-04-26 14:07:31
 */
import { Icon } from 'antd';

export const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1832818_7igz04rkept.js'
});
